import { render, staticRenderFns } from "./ColdStorage.vue?vue&type=template&id=15ef51fd"
import script from "./ColdStorage.vue?vue&type=script&lang=js"
export * from "./ColdStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports